
import { defineComponent, onBeforeMount, ref } from 'vue'
import { IdfButton, IdfTextIcon } from '@invivodf/ui-kit'

import { useAuthentication } from '@/retail/contexts/user/application/composables/useAuthentication'
import { useRouter } from '@invivodf/common/src/application/composables/useRouter'

const GERNERIC_ERROR_MESSAGE = "Une erreur s'est produite, veuillez retourner sur la page de connexion"
const OUTDATED_PASSWORD_ERROR_MESSAGE =
  'Votre mot de passe est expiré, veuillez le réinitialiser via "Mot de passe oublié ?" sur la page de connexion'
const OUTDATED_PASSWORD_MESSAGE_KEY = 'expired-password'

export default defineComponent({
  components: {
    IdfButton,
    IdfTextIcon,
  },
  setup() {
    const isError = ref(false)
    const messageToDisplay = ref('En cours de connexion...')
    const { handleRedirect: handleRedirectAuth0, logout } = useAuthentication()
    const router = useRouter()

    onBeforeMount(async () => {
      try {
        const { appState } = await handleRedirectAuth0()
        const redirectUriAfterLogin = appState?.redirectUriAfterLogin || '/'
        router.push({ path: redirectUriAfterLogin })
      } catch (err) {
        console.error('error handling auth0 incoming redirect', err)
        isError.value = true
        if (err.message === OUTDATED_PASSWORD_MESSAGE_KEY) messageToDisplay.value = OUTDATED_PASSWORD_ERROR_MESSAGE
        else messageToDisplay.value = GERNERIC_ERROR_MESSAGE
      }
    })

    return {
      messageToDisplay,
      logout,
      isError,
    }
  },
})
